<template>
	<div>
		<header-page
			name="page-process"
			:title="$route.meta.title"
		/>
		<div class="px-5">
			<app-table
				class="mt-5 is-not-selectable"
				name="table-process"
				:columns="columns"
				:rows="rows"
				:current-page="currentPage"
				:last-page="lastPage"
				@on-page="changePage"
				@on-search-event="onSearchInput"
			>
				<template slot="rows" slot-scope="props">
					<td
						class="is-not-selectable"
						v-show="showRow(columns, 1)"
					>{{ props.row.code }}</td>
					<td v-show="showRow(columns, 2)">{{ props.row.name }}</td>
					<td v-show="showRow(columns, 3)">{{ props.row.scope }}</td>
					<td v-show="showRow(columns, 4)">{{ props.row.module }}</td>
					<td v-show="showRow(columns, 5)">{{ props.row.order }}</td>
					<td v-show="showRow(columns, 6)">{{ props.row.description }}</td>
					<td v-show="showRow(columns, 7)">{{ props.row.urlImage }}</td>
					<td v-show="showRow(columns, 8)">
						<app-tooltip-button
								color="green"
								icon="edit"
								text="Editar"
								@click-icon="editProcess(props.row)"
							/>
						<app-tooltip-button
							color="red"
							icon="delete"
							text="Eliminar"
							@click-icon="openModalConfirmation(props.row)"
						/>	
					</td>
				</template>
			</app-table>
			<app-confirmation-modal
				:loading="loading"
				:show-modal="modalConfirmation.value"
				@cancel="cancelModalConfirmation"
				@confirm="confirm()"
			/>
		</div>
		<quick-actions
			v-if="$route.name === 'page-process'"
			:actions="actions"
			@open-modal="openModal"
		></quick-actions>
		<router-view></router-view>
	</div>
</template>

<script>
import appConfirmationModal from '@/components/shared/app-confirmation-modal';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import quickActions from '@/components/shared/quick-actions';

function created() {
	this.loadProcess();
}

async function loadProcess() {
	const params = {
		page: this.params.page,
		perPage: this.params.perPage,
		search: this.params.search,
		projectCode: this.$route.params.codeProject,
	};
	try {
		const response = await this.$http.get('process', { params });
		this.rows = response.data.data;
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showError();
	}
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadProcess();
}

function onSearchInput(value) {
	this.params.search = value ? value.trim() : null;
	this.loadProcess();
}

function openModal() {
	this.goTo('create-process');
}

function editProcess({ id }) {
	this.goTo('edit-process', { params: { id } });
}

async function confirm() {
	this.loading = true;
	this.$http
		.delete(`process/${this.modalConfirmation.selectedRow.id}`)
		.then(() => {
			this.showNotification('Proceso eliminado.');
		})
		.catch((error) => {
			if (error.status === 405) {
				if (error.data.message === 'PROCESS_NOT_FOUND') {
					this.showError('Proceso no existe.');
				}
				if (error.data.message === 'PROCESS_HAS_ASSOCIATED_DATA') {
					this.showError('Este proceso no esta asociado.');
				}
			}
		})
		.finally(() => {
			this.loading = false;
			this.modalConfirmation.value = false;
			this.loadProcess();
		});
}

function data() {
	return {
		actions: [
			{
				id: 1,
				code: 'CP',
				text: 'Crear Proceso',
				icon: 'account_tree',
				active: true,
			},
		],
		columns: [
			{ id: 1, name: 'Código', value: 'code', checked: true, visible: true },
			{ id: 2, name: 'Nombre', value: 'name', checked: true, visible: true },
			{ id: 3, name: 'Alcance', value: 'scope', checked: true, visible: true },
			{ id: 4, name: 'Modulo', value: 'module', checked: true, visible: true },
			{ id: 5, name: 'Orden', value: 'order', checked: true, visible: true },
			{ id: 6, name: 'Descripción', value: 'description', checked: true, visible: true },
			{ id: 7, name: 'Imagen', value: 'image', checked: true, visible: true },
			{ id: 8, name: 'Acciones', checked: true, visible: true },
		],
		currentPage: 1,
		idProcess: '',
		loading: false,
		lastPage: 0,
		params: {
			search: null,
			page: 1,
			perPage: 10,
		},
		rows: [],
	};
}

export default {
	name: 'page-process',
	data,
	created,
	components: {
		appConfirmationModal,
		appTooltipButton,
		quickActions,
	},
	watch: {
		$route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-process') {
					this.loadProcess();
				}
			}
		},
	},
	methods: {
		confirm,
		changePage,
		editProcess,
		loadProcess,
		openModal,
		onSearchInput,
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/process/page-process.vue